/* IMPORTS
	You can import directly from node_modules here.
*/
import $ from 'jQuery';
// import 'what-input';

/*
	LIBRARY IMPORTS
	Utilities, plugins, and behaviors that aren't tied to a specific component.
*/
import './before-libs/lazysizes-config.js';

import './libs/hoverintent.min.js';
import './libs/lazysizes-4.0.0.js';
import './libs/responsive-tables.js';
import './libs/smoothscroll-polyfill.min.js';
// import './libs/splide.min.js';
import './libs/webfontloader-1.6.28.js';

/*
  Global Imports
 */
import './after-libs/lazyload-manual.js';
import global from './after-libs/global.js';
// import './after-libs/web-font-loader.js';
import fixedProgressNavigation from './after-libs/fixedProgressNavigation';

/*
	Module IMPORTS
	For specific components.
*/
// import '../../modules/accordion/js/accordion.js';
import animatedText from '../../modules/animatedText/js/animatedText';
import homeHero from '../../modules/homeHero/js/homeHero';

// Easy console access to jQuery through '$'
window.$ = $;

/* INITIALIZATION */
$(() => {
	$('body').addClass('document-ready');
});

$(document).ready(function() {
	/* Higher priority first, lower priority later */
	global();

	fixedProgressNavigation();
	animatedText();
	homeHero();
});

// FOUC on-fully-loaded make the page visible:
addEventListener('load', (e) => {
	document.documentElement.style.visibility = 'visible';
});
